export default {
  name: 'PaySuccess',

  data() {
    return {}
  },

  mounted() {
    this.init();
  },

  methods:{
    async init() {
      
    }
  }
}
